module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/circle-c57bfcabb5810eecccefd2294b3fcdf9.svg";